module.exports = __webpack_public_path__ + "media/images/card-amex-0664db3d2b4ffbf8a6c20f390fa7fd1a.svg";